export const footerMenu = [
    { label: "Home", href: "/" },
    { label: "Contact Us", href: "/contact-us" },
    {
        label: "Privacy Policy",
        href: "/privacy-policy",
    },
];
